import { createSlice } from "@reduxjs/toolkit";
import { fetchClientDashboard } from "../Thunks/clientsThunk";
import { isSupersededRequestPayload } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
  /** Latest client id we started a fetch for; ignores stale fulfill/reject when switching clients. */
  fetchingForClientId: null,
};

export const clientDashboardSlice = createSlice({
  name: "clientDashboard",
  initialState,
  reducers: {
    clearClientDashboard: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
      state.fetchingForClientId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientDashboard.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.fetchingForClientId = action.meta.arg;
      })
      .addCase(fetchClientDashboard.fulfilled, (state, action) => {
        if (String(action.meta.arg) !== String(state.fetchingForClientId)) return;
        const inner = action.payload?.data ?? action.payload;
        state.loading = false;
        state.error = null;
        state.data = inner ?? null;
      })
      .addCase(fetchClientDashboard.rejected, (state, action) => {
        if (isSupersededRequestPayload(action.payload)) return;
        if (String(action.meta.arg) !== String(state.fetchingForClientId)) return;
        state.loading = false;
        state.error = action.payload ?? action.error?.message ?? "Failed to load client dashboard";
      });
  },
});

export const { clearClientDashboard } = clientDashboardSlice.actions;
export const selectClientDashboardData = (state) => state.clientDashboard.data;
export const selectClientDashboardLoading = (state) => state.clientDashboard.loading;
export const selectClientDashboardError = (state) => state.clientDashboard.error;

export default clientDashboardSlice.reducer;
